import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from '../services/setupInterceptors';

const initialState = {productData:{},similarProducts:[],status:'idle',error:null};

export const getProductDetails= createAsyncThunk(
    "product/getProductDetails",
    async ({slug},thunkAPI)=>{
        const {data} = await axiosClient.get("products/" + slug);    
        return data?.success?data: thunkAPI.rejectWithValue("Error");
    }
)

export const getSimilarProducts = createAsyncThunk(
    "product/getSimilarProducts",
    async ({slug},thunkAPI)=>{
        const {data} = await axiosClient.get("search/similar/" + slug);    
        return data?.success?data: thunkAPI.rejectWithValue("Error");
    }
)

const productSlice = createSlice({
    name:"product",
    initialState,
    extraReducers: (builder) => {
        builder
        .addCase(getProductDetails.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
        .addCase(getProductDetails.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.productData = action.payload.data;
        })
        .addCase(getProductDetails.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        })
        .addCase(getSimilarProducts.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
        .addCase(getSimilarProducts.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.similarProducts = action.payload.data;
        })
        .addCase(getSimilarProducts.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        })
    }
})

export default productSlice.reducer;